import { CompoundCondition, ConditionType, ParsedCondition } from "./types";

const CONDITION_REGEX = /^([a-z-]+):(.+)$/i;
const VALUE_UNIT_REGEX = /^(\d+(?:\.\d+)?)([a-z%]+)?$/i;

export function parseCondition(query: string): ParsedCondition | null {
  const match = query.trim().match(CONDITION_REGEX);
  if (!match) {
    return null;
  }

  const type = match[1];
  const valueWithUnit = match[2];

  if (!type || !valueWithUnit || !isValidConditionType(type)) {
    return null;
  }

  const valueMatch = valueWithUnit.match(VALUE_UNIT_REGEX);
  if (!valueMatch) {
    return {
      type,
      value: valueWithUnit,
    };
  }

  const value = valueMatch[1];
  const unit = valueMatch[2];

  if (!value) {
    return null;
  }

  return {
    type,
    value,
    unit,
  };
}

export function parseCompoundCondition(query: string): CompoundCondition | null {
  const hasAnd = query.includes("&&");
  const hasOr = query.includes("||");

  if (hasAnd && hasOr) {
    console.warn(`Mixed && and || operators are not supported: ${query}`);
    return null;
  }

  if (!hasAnd && !hasOr) {
    const condition = parseCondition(query);
    if (!condition) return null;
    return { operator: null, conditions: [condition] };
  }

  const operator = hasAnd ? "AND" : "OR";
  const separator = hasAnd ? "&&" : "||";
  const parts = query.split(separator);

  const conditions: ParsedCondition[] = [];
  for (const part of parts) {
    const condition = parseCondition(part);
    if (!condition) {
      console.warn(`Invalid condition in compound expression: ${part.trim()}`);
      return null;
    }
    conditions.push(condition);
  }

  return { operator, conditions };
}

function isValidConditionType(type: string): type is ConditionType {
  return ["elapsed", "cart", "product"].includes(type);
}
